export default __webpack_public_path__ + "static/media/lucidchart.095a932c.svg";